import {catalogueService} from '../../services/service-factory';

export default {
  data: function() {
    return {
      catalogueService: undefined
    };
  },
  created: function() {
    this.catalogueService = catalogueService;
  }
};
